import { Typography, type TypographyProps } from "@mui/material";

type StatusTextProps = TypographyProps & {
  text?: string;
};

export default function StatusText({ text = "All items loaded", sx, children, ...restProps }: StatusTextProps) {
  return (
    <Typography
      component={children && "div"}
      variant='body2'
      sx={{
        color: "#fff",
        textAlign: "center"
      }}
      {...restProps}
    >
      {children ? children : text}
    </Typography>
  );
}
